import React from "react";
import PropTypes from "prop-types";
import { CircularProgress, Container } from "@material-ui/core";

import useStyles from "./useStyles";

const LoaderSpinner = ({ size = 80 }) => {
  const classes = useStyles();

  return (
    <Container className={classes.root}>
      <CircularProgress className={classes.loader} size={size} />
    </Container>
  );
};

LoaderSpinner.propTypes = {
  size: PropTypes.number,
};

export default LoaderSpinner;
